export function PayrollInvoicePolicyService($http, $q, apexApiUrl) {
    'ngInject';
    return {
        retrievePayrollInvoicePolicies: retrievePayrollInvoicePolicies,
        retrievePayrollInvoicePolicy: retrievePayrollInvoicePolicy,
        savePayrollInvoicePolicy: savePayrollInvoicePolicy,
        deletePayrollInvoicePolicy: deletePayrollInvoicePolicy
    };

    function retrievePayrollInvoicePolicies() {
        return $http({
            method: "GET",
            url: apexApiUrl + "payroll-invoice-policies/",
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    function retrievePayrollInvoicePolicy(payrollInvoicePolicyID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "payroll-invoice-policies/" + payrollInvoicePolicyID,
            headers: { Accept: "application/json" }
        }).then(function (response) {
            return response.data;
        });
    }

    function savePayrollInvoicePolicy(payrollInvoicePolicy) {
        if (payrollInvoicePolicy.PayrollInvoicePolicyID) {
            return updatePayrollInvoicePolicy(payrollInvoicePolicy.PayrollInvoicePolicyID, payrollInvoicePolicy);
        } else {
            return createPayrollInvoicePolicy(payrollInvoicePolicy);
        }
    }

    function createPayrollInvoicePolicy(payrollInvoicePolicy) {
        return $http({
            method: "POST",
            url: apexApiUrl + "payroll-invoice-policies/",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            data: payrollInvoicePolicy
        }).then(function (response) {
            return response.data;
        });
    }

    function updatePayrollInvoicePolicy(payrollInvoicePolicyID, payrollInvoicePolicy) {
        return $http({
            method: "PUT",
            url: apexApiUrl + "payroll-invoice-policies/" + payrollInvoicePolicyID,
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            data: payrollInvoicePolicy
        }).then(function (response) {
            return response.data;
        });
    }

    function deletePayrollInvoicePolicy(payrollInvoicePolicyID) {
        return $http({
            method: "DELETE",
            url: apexApiUrl + "payroll-invoice-policies/" + payrollInvoicePolicyID
        });
    }
}
